module.exports = __webpack_public_path__ + "img/bo.2676eec7.svg";